exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-main[data-v-6f28b516]{color:#333}.color-sub[data-v-6f28b516]{color:#989898}.size-12[data-v-6f28b516]{font-size:12px}.size-14[data-v-6f28b516]{font-size:14px}.size-16[data-v-6f28b516]{font-size:16px}", ""]);

// exports
